<div
  [ngClass]="{
    'layout-inline-menu': true,
    'layout-inline-menu-active': main.activeInlineProfile
  }"
  *ngIf="
    !main.isMobile() && (main.isStatic() || main.isSlim() || main.isSidebar())
  "
>
  <a
    class="layout-inline-menu-action"
    (click)="main.activeInlineProfile = !main.activeInlineProfile"
  >
    <img
      src="assets/images/profile-image.png"
      style="width: 44px; height: 44px"
    />
    <span class="layout-inline-menu-text">{{ accountFullName }}</span>
    <i class="layout-inline-menu-icon fa fa-angle-down"></i>
  </a>

  <ul
    class="layout-inline-menu-action-panel"
    [@inline]="main.activeInlineProfile ? 'visibleAnimated' : 'hiddenAnimated'"
  >
    <li class="layout-inline-menu-action-item">
      <a [routerLink]="['message-us']">
        <i class="fas fa-envelope-open-text"></i>
        <span>{{ "page:Message_us" | i18next }}</span>
      </a>
    </li>
    <li class="layout-inline-menu-action-item">
      <a [routerLink]="" (click)="this.identityService.logout()">
        <i class="fa fa-power-off fa-fw"></i>
        <span>{{ "Logout" | i18next }}</span>
      </a>
    </li>

    <!-- <li class="layout-inline-menu-action-item">
            <a [routerLink]="['settings']">
                <i class="fa fa-cog fa-fw"></i>
                <span>{{'page:Settings' | i18next}}</span>
            </a>
        </li> -->
    <!-- <li class="layout-inline-menu-action-item">
            <a>
                <i class="fa fa-user fa-fw"></i>
                <span>{{'page:Profile' | i18next}}</span>
            </a>
        </li> -->
  </ul>
</div>
